import client from 'FrontendJsAssets/common/client'

const cartVoucher = document.getElementById('cart-vouchers')

if (cartVoucher) {
    cartVoucher.addEventListener('rToggle.afterOpen', () => {
        requestAnimationFrame(() => {
            document.querySelector('.js-vouchers-form input[name="voucher"]').focus()
        })
    })
}

$('.js-vouchers-form').on('submit', (e) => e.preventDefault()).validate({
    submitHandler(form) {
        const data = new FormData(form)
        const formInput = form.querySelector('input[name="voucher"]')
        const formSubmit = form.querySelector('button[type="submit"]')

        formInput.blur()
        formSubmit.classList.add('is-loading')

        client
            .post(form.action, data)
            .then((response) => {
                const data = response.data

                Eshop.tippyAlert(formSubmit, data.message, {
                    theme: data.status ? 'success' : 'error'
                })

                if (data.status) {
                    location.reload();
                } else {
                    formSubmit.classList.remove('is-loading');
                }
            })
            .catch((error) => {
                Eshop.tippyAlert(formSubmit, form.dataset.generalError, {
                    theme: 'error'
                })

                formSubmit.classList.remove('is-loading');
            })
    }
});